export default __webpack_public_path__ + "static/media/noa-34.a8682257.jpg";